<script setup lang="ts">
const { tabindex = 0 } = defineProps<{
  disabled?: boolean
  checked?: boolean
  tabindex?: number | `${number}`
  truncate?: boolean
}>()

defineEmits(['click'])
</script>
<template>
  <label
    role="radio"
    class="focus:ring-secondary-200 group relative flex min-h-9 w-full items-center rounded-md p-2 pr-4 ring-offset-2 outline-none focus:ring-2"
    :class="{
      'cursor-pointer': !disabled,
      'cursor-default': disabled,
    }"
    :tabindex="tabindex"
    @click.prevent="!disabled && $emit('click')"
  >
    <div class="mt-px">
      <input
        class="focus:ring-secondary-200 group-focus:ring-secondary-200 block h-4 w-4 appearance-none rounded-full border bg-neutral-100 ring-offset-2 outline-none group-focus:ring-2 focus:ring-2"
        :class="{
          'border-secondary-600 border border-4 bg-white': checked,
          'hover:bg-neutral-light border-neutral-300 text-neutral-900':
            !checked,
        }"
        :checked="checked"
        tabindex="-1"
        type="radio"
      />
    </div>
    <div
      class="body-2 w-full pl-3 text-left text-neutral-900"
      :class="{
        'truncate whitespace-nowrap': truncate,
      }"
    >
      <slot />
    </div>
  </label>
</template>
